import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import Slidder from '../../Slidder';
import TextWithDefinition from '../../../TextWithDefinition';
import { useDispatch, useSelector } from 'react-redux';
import { setInventoryReplThreshold } from '../../../../redux/actions/rcaActions';
import { saveEventTrack } from '../../../../redux/actions/eventTrackAction';
import { UserPortalContext } from '../../../../context/appcontext';
import { GUIDED_INSIGHTS_RCA } from '../../../../constants/constant';

const fontProperties = {
	fontSize: '20px',
	fontWeight: 700,
	lineHeight: '28px',
	margin: '0 0 0 16px',
};

const MetricTile = ({ item, data, updateReplInstock }) => {
	const dispatch = useDispatch();
	const portalUserContext = useContext(UserPortalContext);

	const { threshold } = useSelector((state) => state.rcaReducer);

	const valueRenderers = {
		sales: (value) => {
			const sign = value < 0 ? '-' : '';
			return (
				<Typography sx={fontProperties}>{`${sign}$${Number(
					Math.abs(value)
				).toLocaleString('en-GB', {
					maximumFractionDigits: 2,
				})}`}</Typography>
			);
		},
		item: (value) => (
			<Box
				sx={{
					display: 'flex',
					alignItems: 'center',
					gap: '8px',
				}}>
				<Typography sx={fontProperties}>{value}</Typography>
				<Typography
					sx={{
						fontSize: '12px',
						fontWeight: 400,
						lineHeight: '16px',
					}}>
					items
				</Typography>
			</Box>
		),
		percent: (value) => (
			<Typography sx={fontProperties}>
				{Number(value).toLocaleString('en-GB', {
					maximumFractionDigits: 2,
				})}
				%
			</Typography>
		),
	};

	const getValue = (val) => {
		// Event Tracking for Inventory Repl. Change
		const request = {
			event: `Inventory Repl. threshold value has been set to ${val}%`,
			event_description: 'AI Insights Tab',
			attributes: GUIDED_INSIGHTS_RCA,
		};
		dispatch(saveEventTrack({ request, portalUserContext }));

		// Dispatch the new value
		dispatch(setInventoryReplThreshold(val));
	};

	return (
		<Box
			key={item.id}
			sx={{
				display: 'column',
				alignItems: 'center',
				width: '100%',
			}}>
			<Box
				sx={{
					height: '32px',
					display: 'flex',
					alignItems: 'center',
					gap: '4px',
				}}>
				<Box
					sx={{
						display: 'flex',
						alignItems: 'center',
					}}>
					<TextWithDefinition
						text={item.label}
						styles={{
							fontSize: '12px',
							lineHeight: '16px',
							margin: '0 0 0 16px',
							paddingRight: '3px',
						}}
						definitionId={item?.definitionId}
						hasDefinition={item?.hasDefinition}
					/>
					<Typography
						sx={{
							fontSize: '12px',
							lineHeight: '16px',
							textDecoration: 'none',
						}}>
						{item.hasEdit && `< ${threshold} %`}
					</Typography>
				</Box>
				{item.hasEdit && (
					<Slidder
						defaultValue={threshold}
						getValue={getValue}
						updateReplInstock={updateReplInstock}
					/>
				)}
			</Box>
			<Box
				sx={{
					display: 'flex',
					alignItems: 'center',
					height: '32px',
					gap: '8px',
				}}>
				<Box>
					{data[item.id] || data[item.id] === 0
						? valueRenderers[item?.type](data[item?.id])
						: ''}
				</Box>
			</Box>
		</Box>
	);
};

MetricTile.propTypes = {
	item: PropTypes.object,
	data: PropTypes.object,
	updateReplInstock: PropTypes.func,
};

export default MetricTile;
